const FirebaseLogo = ({ width = 75, height = 75 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5 45.625C20.3281 46.3594 22.3125 46.7969 24.4062 46.875C27.2344 46.9688 29.9063 46.3906 32.3125 45.2813C29.4375 44.1563 26.8281 42.5 24.6094 40.4375C23.1598 42.7521 21.0319 44.5635 18.5156 45.625H18.5Z"
        fill="#FF9100"
      />
      <path
        d="M24.594 40.4374C19.5159 35.7499 16.4378 28.9531 16.7034 21.4999C16.7034 21.2656 16.719 21.0156 16.7347 20.7812C14.4808 20.2061 12.1154 20.2331 9.87528 20.8593C8.5159 23.2343 7.7034 25.9531 7.59403 28.8749C7.3284 36.4062 11.8909 42.9843 18.5003 45.6406C21.0237 44.5906 23.1547 42.7765 24.594 40.4531V40.4374Z"
        fill="#FFC400"
      />
      <path
        d="M24.5939 40.4375C25.8119 38.4872 26.4962 36.2511 26.5782 33.9531C26.797 27.6719 22.5782 22.2813 16.7345 20.7656C16.7345 21 16.7032 21.25 16.7032 21.4844C16.5725 25.0236 17.2102 28.549 18.5723 31.8182C19.9345 35.0874 21.9888 38.0226 24.5939 40.4219V40.4375Z"
        fill="#FF9100"
      />
      <path
        d="M25.9219 3.125C22.5938 5.78125 19.9688 9.29688 18.375 13.3437C17.4434 15.7167 16.8898 18.2211 16.7344 20.7656C19.6315 21.5145 22.1862 23.2297 23.9762 25.6277C25.7661 28.0256 26.684 30.9627 26.5781 33.9531C26.5057 36.2527 25.8207 38.4912 24.5937 40.4375C26.8392 42.5154 29.4512 44.1579 32.2969 45.2812C38.0781 42.6094 42.1719 36.875 42.4063 30.0781C42.5625 25.6719 40.875 21.75 38.4844 18.4375C35.9531 14.9375 25.9219 3.14062 25.9219 3.14062V3.125Z"
        fill="#DD2C00"
      />
    </svg>
  );
};

export default FirebaseLogo;
